module.exports = __webpack_public_path__ + "img/2.874add66.webp";